module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Italic-b680c2ab2d2bb0f80bf5aeb8ace676ac.eot";